import React from 'react';

import { OrgChartCompanyNotesProps } from './interfaces';

const OrgChartCompanyNotes = ({ notes }: OrgChartCompanyNotesProps) => {
  return (
    <div
      className="mb-64 border-b-0 border-l-0 border-r-0 border-t border-solid border-grayscale-gray pt-12"
      data-testid="org-chart-notes"
    >
      <p className="font-suisse-intl text-[14px] font-normal leading-[130%] text-grayscale-gray">
        {notes.text}
      </p>
      {notes.pictureAuthor && (
        <p className="font-suisse-intl text-[14px] font-normal leading-[130%] text-grayscale-gray">
          {notes.pictureAuthor}
        </p>
      )}
    </div>
  );
};

export default OrgChartCompanyNotes;
